<template>
    <header-helper id="grosses-combined">
        <span>
            <span>LW</span> Last Week
        </span>
        <span>
            <span>LS</span> Last Season
        </span>
    </header-helper>
</template>

<script>
import HeaderHelper from 'src/components/GrossesHeader/HeaderHelper';

export default {
    components: {
        HeaderHelper,
    },
};
</script>
